import { useEffect, useState } from "react";
import { BackSvgPPP } from "../svgImages";
import "./style.scss";

interface IAccommodationDetailsCard {
  roomsData: any[];
  shipName: string;
}

const AccommodationDetailsCard: React.FC<IAccommodationDetailsCard> = ({roomsData, shipName}) => {
  const [detailsTrigger, setDetailsTrigger] = useState<boolean>(true);
  const [selectedCabin, setSelectedCabin] = useState<number>(0); //array index based selection
  const [arrowDisplay, setArrowDisplay] = useState<boolean>(false);

  const handleRightClick = () => {
    document.getElementById("right-arrow")?.addEventListener("click", function () {
      const container = document.getElementById("cabin-slider-wrapper") as HTMLDivElement;
      if (container) {
        container.scrollLeft += container.clientWidth;
      }
    });
  };

  const handleLeftClick = () => {
    document.getElementById("left-arrow")?.addEventListener("click", function () {
      const container = document.getElementById("cabin-slider-wrapper") as HTMLDivElement;
      if (container) {
        container.scrollLeft -= container.clientWidth;
      }
    });
  };

  useEffect(() => { 
    const parentDiv = document.getElementById('relative-button-wrapper');
    const childDiv = document.getElementById('cabin-slider-wrapper');
    if (parentDiv && childDiv) {
      const parentWidth = parentDiv.scrollWidth;
      const childWidth = childDiv.scrollWidth;
      if (childWidth <= parentWidth) setArrowDisplay(false);
      else setArrowDisplay(true);
    }
  }, [roomsData]);
  
  return (
    <div className="accommodation-details-card-wrapper">
      <div
        className={`accommodation-details-header ${detailsTrigger ? "" : "remove-border"}`}
        onClick={() => setDetailsTrigger((prev) => !prev)}
      >
        <span>Accommodation Details</span>
        <span className={`${detailsTrigger ? "open" : "close"}`}>
          <BackSvgPPP fill="black" height={20} />
        </span>
      </div>
      {detailsTrigger && (
        <div className="cabins-detail-wrapper">
          <div className="relative-button-wrapper" id="relative-button-wrapper">
            <div className="cabin-slider-wrapper" id="cabin-slider-wrapper">
              {roomsData?.map((_, index) => {
                return (
                  <div
                    key={index}
                    className={`cabin-button ${selectedCabin === index ? "active" : ""}`}
                    onClick={() => setSelectedCabin(index)}
                  >
                    <span>Cabin {`${index + 1}`.padStart(2, '0')}</span>
                  </div>
                );
              })}
            </div>
            {arrowDisplay && (
              <span className="left-arrow" id="left-arrow" onClick={handleLeftClick}>
                <BackSvgPPP height={16} width={16} />
              </span>
            )}
            {arrowDisplay && (
              <span className="right-arrow" id="right-arrow" onClick={handleRightClick}>
                <BackSvgPPP height={16} width={16} />
              </span>
            )}
          </div>
          <div className="cabin-info-wrapper">
            {/* <div className="cabin-info">
              <span className="secondary-text">Cabin Number</span>
              <span className="primary-text">Cabin {selectedCabin + 1 < 10 ? "0" + (selectedCabin + 1) : selectedCabin + 1}</span>
            </div> */}
            <div className="cabin-info">
              <span className="secondary-text">Cabin Category</span>
              <span className="primary-text">{roomsData[selectedCabin]?.categoryName}</span>
            </div>
            <div className="cabin-info">
              <span className="secondary-text">Guests No.</span>
              <span className="primary-text">
                {`0${
                  roomsData[selectedCabin]?.guests?.adults +
                  roomsData[selectedCabin]?.guests?.children +
                  roomsData[selectedCabin]?.guests?.infants
                } `}
                ({`0${roomsData[selectedCabin]?.guests?.adults}AD`}
                {roomsData[selectedCabin]?.guests?.children > 0 && `, 0${roomsData[selectedCabin]?.guests?.children}CH`}
                {roomsData[selectedCabin]?.guests?.infants > 0 && `, 0${roomsData[selectedCabin]?.guests?.infants}IN`})
              </span>
            </div>
            {!!roomsData[selectedCabin]?.room?.room?.deckNo && <div className="cabin-info">
              <span className="secondary-text">Deck Number</span>
              <span className="primary-text">
                {roomsData[selectedCabin]?.room?.room?.deckNo < 10
                  ? `0${roomsData[selectedCabin]?.room?.room?.deckNo}`
                  : roomsData[selectedCabin]?.room?.room?.deckNo}
              </span>
            </div>}
            {!!roomsData[selectedCabin]?.room?.room?.number && <div className="cabin-info">
              <span className="secondary-text">Cabin Number</span>
              <span className="primary-text">{roomsData[selectedCabin]?.room?.room?.number}</span>
            </div>}
            <div className="cabin-info">
              <span className="secondary-text">Ship Name</span>
              <span className="primary-text">{shipName}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccommodationDetailsCard;
